import * as React from 'react';
import '../../_assets/css/file.css';
import axios from 'axios';

import { baseURL } from '../../_helpers';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import PhoneOutlineIcon from 'mdi-react/PhoneOutlineIcon';
import Input from 'react-phone-number-input/input'

export class PromoCode extends React.Component {

    constructor(props) {
        super(props)
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            phone_number: '',
            showError: false,
            email_address: '',
            userDetail: false,
            isShowError: false,
        }

        localStorage.setItem("phone_2", null);
    }

    onSubmit(e) {
        e.preventDefault();

        this.setState({ isLoading: true });
        axios.get(baseURL + 'promocodesearch/' + this.state.promocode, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        }).then((response) => {

          
            if (response.data.status) {
                this.setState({
                    statusMessage: "Success! Redirecting....",
                    isShowError: true, isLoading: false, showError: false,
                });
                localStorage.setItem('promocode',   response.data.data.msisdn);
                localStorage.setItem('promocode_id',   response.data.data.id);
                localStorage.setItem('promocode_income', response.data.data.referral_income)
                setTimeout(() => {
                    this.setState({
                        statusMessage: response.data.message,
                        phone_number: '',
                        email_address: '',
                        userDetail: true,
                        isShowError: true, isLoading: false, showError: false,
                    });
                }, 1000);

            } else {

                this.setState({ statusMessage: response.data.message, email_address: '', phone_number: '', userDetail: false, showError: true, isShowError: false, isLoading: false });
            }
        }).catch(error => {
            console.log('bayoo', error.response)
            this.setState({
                showError: true,
                isShowError: false,
                phone_number: '',
                email_address: '',
                userDetail: false,
                statusMessage: error.response.data.message,
                submitted: true,
                isLoading: false
            });
        });


    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    render() {
        const { showComponent } = this.state;
        const { hideComponent, userDetail } = this.state;

        return (
            <div className="pcoded-main-container">
                {userDetail === true ? <Redirect to='promocodereferral' /> : null}
                {/* {showComponent && (
                    <div>
                        {this.state.showComponent ?
                            <peopleView /> : null
                        }
                    </div>
                )} */}
                {!hideComponent && (
                    <>

                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody>
                                    <h4 className="bold-text">PromoCode Search</h4>
                                    <div className="card__title">
                                        <h5 className="bold-text">Fill the Below Field to Proceed </h5>
                                    </div>
                                    {this.state.showError ? <div style={{ color: 'red' }}>
                                        {this.state.statusMessage}
                                    </div> : null}
                                    {this.state.isShowError ? (
                                        <div color="success" style={{ fontSize: "13px", color: "green" }}>
                                            {this.state.statusMessage}
                                        </div>
                                    ) : null}<br></br>
                                    <form className="col-md-8 offset-md-2" onSubmit={this.onSubmit}>
                                        <span className="form__form-group-label">PromoCodes</span>
                                        <div className="form__form-group-field"><div className="form__form-group-icon">
                                            <Card />
                                        </div>
                                            <input id="input" type="text" className="form-control input-md"
                                                name="promocode" placeholder="Enter PromoCode"
                                                value={this.state.promocode} onChange={this.handleChange} />
                                        </div>
                                        <div className="col-12">
                                            <br />
                                            <Button type="submit" outline color="primary" className="float-right" >
                                                {this.state.isLoading ? "Please Wait..." : "Search"}  <i className="fa fa-search"></i>
                                            </Button> &nbsp;&nbsp;&nbsp;
                                        </div>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </>

                )
                }

            </div>
        )

    }

}
